import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import ElementUI from 'element-ui';
import lendingContentZh from '@/content/lending/zh'
import lendingContentEn from '@/content/lending/en'
import lendingContentJa from '@/content/lending/ja'
import lendingContentKo from '@/content/lending/ko'
import lendingContentDe from '@/content/lending/de'
import lendingContentFr from '@/content/lending/fr'
import lendingContentIt from '@/content/lending/it'
import lendingContentAr from '@/content/lending/ar'
import lendingContentEs from '@/content/lending/es'
import lendingContentHk from '@/content/lending/hk'

/** 国际化 **/
Vue.use(VueI18n);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': Object.assign(require('@/common/lang/zh-CN'), zhLocale, lendingContentZh),
    'en': Object.assign(require('@/common/lang/en'), enLocale, lendingContentEn),
    'ja': Object.assign(require('@/common/lang/ja'), enLocale, lendingContentJa),
    'ko': Object.assign(require('@/common/lang/ko'), enLocale, lendingContentKo),
    'de': Object.assign(require('@/common/lang/de'), enLocale, lendingContentDe),
    'fr': Object.assign(require('@/common/lang/fr'), enLocale, lendingContentFr),
    'it': Object.assign(require('@/common/lang/it'), enLocale, lendingContentIt),
    'ar': Object.assign(require('@/common/lang/ar'), enLocale, lendingContentAr),
    'hk': Object.assign(require('@/common/lang/zh-HK'), enLocale, lendingContentHk),
    'es': Object.assign(require('@/common/lang/es'), enLocale, lendingContentEs),
  }
});

export default i18n